import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

interface VersionInfo { base: string; sha: string; version: string; }

const AppFooter: React.FC = () => {
  const [v, setV] = useState<VersionInfo | null>(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL ?? ''}/api/version`)
      .then(r => r.ok ? r.json() : null)
      .then(setV)
      .catch(() => {});
  }, []);

  return (
    <footer className="mt-12 border-t border-gray-800 py-4 text-xs text-gray-500 text-center">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <Link to="/about" className="hover:text-gray-300">Über das Projekt</Link>
        <span>·</span>
        <Link to="/impressum" className="hover:text-gray-300">Impressum</Link>
        <span>·</span>
        <Link to="/datenschutz" className="hover:text-gray-300">Datenschutz</Link>
        {v && (
          <>
            <span>·</span>
            <span className="font-mono">{v.version}</span>
          </>
        )}
      </div>
    </footer>
  );
};

export default AppFooter;
